module.exports = __webpack_public_path__ + "static/img/q6.172c4e9c.jpg";